/**
 * 缓存说明:采集端定时遥控缓存
 */
import vm from '@/cache/storeTools.js'
import timeRemoteControlApi from '@/components/api/timeRemoteControl/timeRemoteControlApi.js'

var basestate = {
	pkidToList:{}
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getListByDeviceNoAndParentArea(state,getters){
			return (deviceNo,parentArea)=>{
				return vm.getBeanById(store,state.pkidToList,"getListByDeviceNoAndParentArea",[])(deviceNo+"_"+parentArea)
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getListByDeviceNoAndParentArea(state,pkid){
			var ids = pkid.split("_")
			timeRemoteControlApi.findListByDeviceNoAndParentArea(ids[0],ids[1],respon=>{
				vm.Vue.set(state.pkidToList,pkid,respon)
			})
		}
	}
})

//对外提供
export default store